import './index.css';

const WechatZdCode: React.FC<{onClose: ()=> void, url: string,canClose:any}> = (props) => {
    const {onClose,  url ,canClose} = props
    return (
        <div className="wrapWechat">
            <div className='wechatTitle'>
                <div className='wechatTitleContent'>下载APP</div>
                {canClose===1 && <div className='wechatClose' onClick={onClose}></div>}
            </div>
            <div className="wechatBox">
                <img src={url} alt="" />
            </div>
            <div className='wechatTips'>1、截屏将图片保存至手机</div>
            <div className='wechatTips'>2、使用微信“扫一扫”识别二维码</div>
            <div className='wechatTips'>3、下载并安装APP</div>
        </div>)
}



export default WechatZdCode;
